module.exports = __webpack_public_path__ + "static/media/blocker_own.0d324b67.png";